<template>
  <avue-crud
    ref="crud"
    :option="option"
    v-model:page="page"
    :table-loading="loading"
    @on-load="getList"
    @row-update="rowUpdate"
    @row-save="rowSave"
    @row-del="rowDel"
    @refresh-change="refreshChange"
    @search-reset="searchChange"
    @search-change="searchChange"
    v-model="form"
    :data="data"
  >
  </avue-crud>
</template>
<script>
import { mapGetters } from "vuex";
import { getList, update, add, del } from "@/api/salesCloud/serviceHotline.js";
import serviceHotlineOption from "@/const/salesCloud/serviceHotlineOption.js";
export default {
  data() {
    return {
      page: {},
      form: {},
      params: {},
      loading: false,
      data: [],
      option: serviceHotlineOption(this),
    };
  },
  created() {},
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    getList() {
      this.loading = true;
      const data = Object.assign(
        {
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize,
        },
        this.params
      );
      this.data = [];
      getList(data).then((res) => {
        const data = JSON.parse(res.data);
        this.loading = false;
        this.page.total = data.total;
        const result = data.rows;
        this.data = result;
      });
    },
    rowSave(row, done, loading) {
      add(
        Object.assign(
          {
            createUser: this.userInfo.name,
          },
          row
        )
      ).then((res) => {
        if (res.code === "200") {
          this.$message.success("添加成功");
          done();
          this.getList();
        } else {
          this.$message.error(res.message);
          loading();
          done();
        }
      });
    },
    rowUpdate(row, index, done, loading) {
        console.log(index);
      update(
        Object.assign(
          {
            updateUser: this.userInfo.name,
          },
          row
        )
      ).then((res) => {
        if (res.code === "200") {
          this.$message.success("修改成功");
          done();
          this.getList();
        } else {
          this.$message.error(res.message);
          loading();
        }
      });
    },
    rowDel(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return del(row.id).then((res) => {
            if (res.code === "200") {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .then(() => {
          this.$message.success("删除成功");
          this.getList();
        });
    },
    searchChange(params, done) {
      if (done) done();
      this.params = params;
      this.page.currentPage = 1;
      this.getList();
      this.$message.success("搜索成功");
    },
    refreshChange() {
      this.getList();
      this.$message.success("刷新成功");
    },
  },
};
</script>
<style lang="scss" scoped>
// ::v-deep样式穿透.el-scrollbar__wrap
.el-scrollbar__wrap {
  overflow: scroll !important;
}
</style>